<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: zyl
 * @Date: 2020-04-09 13:00:48
 * @LastEditors: zyl
 * @LastEditTime: 2020-04-09 10:12:49
 -->
<template>
  <div class="box" >
    <div class="img-box">
      <div class="img-info" :class="['image' + i]" v-show="currentPage ==i" :ref="'rotateP' + i"  v-for="(item,i) in imageUrlObj.urlList" :key="i"  @mousewheel.prevent="rollImg">
        <img :src="item.filePath"  class="imgItem" alt :ref="'rotate' + i"  @mousedown="move">
      </div>
    </div>
    <div class="operate-btn-box">
      <el-button v-if="multiple" type="primary" @click="handleImg(1)"><i class="el-icon-arrow-left"></i>上一张</el-button>
      <el-button type="primary" @click="rotateImg"><i class="el-icon-refresh-right"></i>旋转</el-button>
      <el-button type="primary" @click="zoomImg('big')"><i class="el-icon-zoom-in"></i>放大</el-button>
      <el-button type="primary" @click="zoomImg('samll')"><i class="el-icon-zoom-out"></i>缩小</el-button>
      <el-button v-if="multiple" type="primary" @click="handleImg(2)">下一张<i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>
<script>
  import {getImgURLOfBase64} from "../../publicMethods/axiosImage";
  export default {
  data() {
    return {
      imageUrlObj: {
        urlList:[],
        index:0
      },
      selIndex:0,
      imgUrl :'',
      multiple:false,
      currentPage: 0,
      deg:0,
    }
  },
  created() {
    let vm = this;
    // 设置图片初始旋转角度
    if(vm.multiple) {
      vm.currentPage = vm.imageUrlObj.index;
    }
  },
  mounted() {
    let vm = this;
    if (localStorage.getItem('viewImageUrl')){
      let urlList = localStorage.getItem('viewImageUrl');
      vm.imageUrlObj = JSON.parse(urlList);
      vm.imageUrlObj.urlList.forEach(item => {
        item.deg = 0;
        item.zoom =100;
      })
      /*多图*/
      if(vm.imageUrlObj.urlList.length>1){
        vm.multiple = true;
        vm.currentPage = vm.imageUrlObj.index;
      }else{
        vm.multiple = false;
        vm.imgUrl = vm.imageUrlObj.urlList[0].filePath;
      }
    }
  },

  watch:{},
  methods: {
    // 拖动图片
    move(e) {
      let vm  = this;
      e.preventDefault()
      // 获取元素
      let left = document.querySelector('.image'+vm.currentPage),
        img = document.querySelector('.image'+vm.currentPage+' .imgItem'),
        x = e.pageX - img.offsetLeft,
        y = e.pageY - img.offsetTop;
      // 添加鼠标移动事件
      left.addEventListener('mousemove', move)
      function move(e) {
        img.style.left = e.pageX - x + 'px'
        img.style.top = e.pageY - y + 'px'
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener('mouseup', function() {
        left.removeEventListener('mousemove', move)
      })
      // 鼠标离开父级元素，把事件移除
      left.addEventListener('mouseout', function() {
        left.removeEventListener('mousemove', move)
      })
    },
    // 缩放图片
    rollImg() {
      let vm = this;
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      var zoom = parseInt(vm.$refs['rotate'+vm.currentPage][0].style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 80 && zoom <500) {
        vm.imageUrlObj.urlList[vm.currentPage].zoom = zoom;
        vm.$refs['rotate'+vm.currentPage][0].style.zoom = zoom + "%";
      }
      return false;
    },
    //放大缩小
    zoomImg(type){
      let vm = this;
      let fileInfo = vm.imageUrlObj.urlList[vm.currentPage];
      if (type === 'samll') { // 缩小
        /*fileInfo.scale -= 0.1;*/
        fileInfo.zoom -= 10;
      } else { // 放大
        /*fileInfo.scale += 0.1*/
        fileInfo.zoom += 10;
      }
      /*if (fileInfo.scale >= 2 || fileInfo.scale <=1) {
        fileInfo.scale = 1;
        vm.$refs['rotate'+vm.currentPage][0].style.transformOrigin = `center`;
      }*/
      if (fileInfo.zoom >= 80 && fileInfo.zoom <500) {
        vm.$refs['rotate'+vm.currentPage][0].style.zoom = fileInfo.zoom + "%";
        vm.imageUrlObj.urlList[vm.currentPage].zoom = fileInfo.zoom;
      }
      // 获取图片当前信息
      /*vm.$refs['rotate'+vm.currentPage][0].style.transform = `rotate(${fileInfo.deg}deg)  scale(${fileInfo.scale})`;
*/
    /*  /!*let test = document.querySelector('.img');
      let rect = test.getBoundingClientRect();*!/
      let rect =vm.$refs['rotate'+vm.currentPage][0].clientHeight;

      if (fileInfo.scale >= 1.5 || fileInfo.scale <=0.5) {
        /!*vm.$refs['rotateP'+vm.currentPage][0].style.width = rect.width*fileInfo.scale+'px';*!/
        vm.$refs['rotateP'+vm.currentPage][0].style.height = '100%';
      }else{
        let height =rect.height+( rect.height * (fileInfo.scale - 1));
        console.log(rect.height +':'+height + '*'+fileInfo.scale );
        vm.$refs['rotateP'+vm.currentPage][0].style.height = height+'px';
      }*/

    },
    //上下翻页
    handleImg (type) {
      let vm = this;
      if (type === 1) { // 上一张
        vm.currentPage++
        if (vm.currentPage >=  vm.imageUrlObj.urlList.length) {
          vm.currentPage = 0
        }
      } else { // 下一张
        vm.currentPage--
        if (vm.currentPage < 0) {
          vm.currentPage =  vm.imageUrlObj.urlList.length - 1
        }
      }
      // 获取图片当前信息
      let fileInfo = vm.imageUrlObj.urlList[this.currentPage];
      vm.$refs['rotate'+vm.currentPage][0].style.transform = `rotate(${fileInfo.deg}deg)  scale(${fileInfo.scale})`
    },
    // 旋转图片
    rotateImg () {
      let vm = this;
      let fileInfo = vm.imageUrlObj.urlList[vm.currentPage];
      fileInfo.deg += 90
      /*if (fileInfo.deg >= 360) {
        fileInfo.deg = 0
      }*/
      vm.$refs['rotate'+vm.currentPage][0].style.transform = `rotate(${fileInfo.deg}deg)`;
    },
  },
};
</script>
<style lang="scss">
  .box {  width: 100%; height:calc(100% - 10px);padding-top: 10px;}
  .operate-btn-box{width: 100%;height: 40px;display: flex;justify-content: center;align-items: center;margin:5px auto 0px;}
  .img-box{width: 100%;height: calc(100% - 50px);overflow:hidden;display: flex;justify-content: center;align-items: center;}
  .img-info{width: 100%;height: 100%;overflow:hidden;position: relative;display: flex;justify-content: center;}
  .img-info img {position: absolute; top: calc(50% - 250px); margin:auto; max-width: 1000px; max-height:500px; cursor: grab;transition: 0.5s}

</style>



// WEBPACK FOOTER //
// src/pages/login/imageView.vue